import React, { useEffect, useState } from "react";
import "./styles.css";
import { TextField, TableRow, RadioGroup, Radio, FormControlLabel, FormControl, IconButton, Autocomplete, CircularProgress, Box } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { UXDataTableWithoutBody, StyledTableBody, StyledTableCell } from "../../../../components/UXDataTable";
import { formatMidasNumber, RoundNumber, globalMessages, GetRequiredSampleSize, GetRequiredSampleSizeUoM, BuildTestingPayload, ConvertUOMs } from "../../../../global";
import { styled } from "@mui/material/styles";
import HelpIcon from '@mui/icons-material/Help';
import ModalMessages from "../../../../components/Modal/ModalSimpleButton";
import ContainerTable from "../../../../components/ContainerTable";
import ModalNoButton from "../../../../components/Modal/ModalNoButton";
import Container from "../../../../api/LIMS/Container";
import { useUser } from "../../../../context/UserContext";
import WorkRequest from "../../../../api/WorkRequest/WorkRequest";
import { GlobalButton } from "../../../styles";
import PrintLabel from "../../../../api/LIMS/PrintLabel";
import PrintInformation from "../../../../components/PrintInformation";

const midasColHeaders = ['MIDAS Number', 'Req. Size', 'Parent Container', 'Container Amt.', 'Sample Description']
const midasColHeaders_Existing = ['MIDAS Number', 'Options', 'Sample Description']
const existingColHeaders = ['Method', 'Container Options', 'Container', 'Req. Size', 'Container Amt.']

const StyledP = styled('p')({
    color: "#000000DE",
    fontFamily: "EMprint",
    fontWeight: "600",
    fontSize: "16px",
    paddingTop: "1rem",
    paddingLeft: ".6rem",
    paddingBottom: "1rem"
})

const WorkRequestContainerManagement = ({
    mySamplesInfo, setMySamplesInfo, availableLocations, methods, setMethods, selectedMyContainers, availableUOMs,
    containeringMethod, setContaineringMethod, prepareData, myWorkRequest,
    onGetRecommendation, setOnGetRecommendation, readOnly
}) => {
    const [sampleRowOpen, setSampleRowOpen] = useState([]);
    const [modalMessagesOpen, setModalMessagesOpen] = useState(false);
    const modalMessagesButtonText = 'Ok';
    const [modalMessagesTitle, setModalMessagesTitle] = useState('');
    const [modalMessagesText, setModalMessagesText] = useState('');
    //const [triggerContainerReload, setTriggerContainerReload] = useState(false);
    const [containerErrorChecks, setContainerErrorChecks] = useState(PopulateErrorInfo());
    const [modalNoButtonOpen, setModalNoButtonOpen] = useState(false);
    const [modalNoButtonTitle, setModalNoButtonTitle] = useState('');
    const [modalNoButtonText, setModalNoButtonText] = useState('');
    const [minSampleSize, setMinSampleSize] = useState(0);
    const [masterUoM, setMasterUoM] = useState();
    const [loading, setLoading] = useState();
    const { username } = useUser();
    const [printLabelInfo, setPrintLabelInfo] = useState(null);
    const [printInfoOpen, setPrintInfoOpen] = useState(false);
    const [disablePrintContainers, setDisablePrintContainers] = useState(true);

    const ownerContainer = myWorkRequest.requestedByEmail ?? username;

    function PopulateErrorInfo() {
        var containerErrors = [];
        let i = 0;
        while (i < selectedMyContainers.length) {
            containerErrors.push({ containerErrorInfo: [] });
            i++;
        }
        return containerErrors;
    }
    
    useEffect(() => {
        if (availableUOMs.length === 0 || !methods || methods.length < 1)
            return;
        let tempMasterUoM = availableUOMs.find(e => e.uoMName === GetRequiredSampleSizeUoM(methods[0]));
        let currentUOM;
        let tempSampleSize = 0;
        methods.forEach(oMethod => {
            currentUOM = availableUOMs.find(e => e.uoMName === GetRequiredSampleSizeUoM(oMethod));
            tempSampleSize = tempSampleSize + ConvertUOMs(null, null, GetRequiredSampleSize(oMethod), currentUOM, tempMasterUoM);
        });
        setMinSampleSize(RoundNumber(tempSampleSize, 2));
        setMasterUoM(tempMasterUoM);
    }, [methods, availableUOMs]);


    useEffect(() => {
        if (onGetRecommendation) {
            LoadContainers();
            setOnGetRecommendation(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onGetRecommendation]);

    useEffect(() => {
        if (mySamplesInfo.length !== containerErrorChecks.length) {
            const newErrors = [...containerErrorChecks];
            
            for (let i = containerErrorChecks.length; i < mySamplesInfo.length; i++) {
                const sample = mySamplesInfo[i];
                newErrors.push({
                    containerErrorInfo: [{
                        containerType: false,
                        size: false,
                        currentAmount: false,
                        uom: false,
                        location: sample?.newContainer?.location === null ? null : false,
                        ownerEmail: sample?.newContainer?.ownerEmail === null ? null : false
                    }]
                });
            }
            
            if (mySamplesInfo.length < containerErrorChecks.length) {
                newErrors.splice(mySamplesInfo.length);
            }
            
            setContainerErrorChecks(newErrors);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mySamplesInfo]);

    const hasError = containerErrorChecks.some((containerError) =>
        containerError.containerErrorInfo.some((container) => Object.values(container).includes(true))
    ) ?? false;

    const getUniqueContainerNumber = (baseNumber, usedNumbers) => {
        if (baseNumber === null || baseNumber === undefined || baseNumber === '') {
            return baseNumber;
        }

        const originalType = typeof baseNumber;
        const baseAsString = String(baseNumber);

        if (!usedNumbers.has(baseAsString)) {
            usedNumbers.add(baseAsString);
            return baseNumber;
        }

        const isNumeric = /^\d+$/.test(baseAsString);

        if (isNumeric) {
            let nextValue = Number(baseAsString);
            let candidate = baseAsString;

            while (usedNumbers.has(candidate)) {
                nextValue += 1;
                candidate = String(nextValue);
            }

            usedNumbers.add(candidate);
            return originalType === 'number' ? nextValue : candidate;
        }

        let suffix = 2;
        let candidate = `${baseAsString}-${suffix}`;
        while (usedNumbers.has(candidate)) {
            suffix += 1;
            candidate = `${baseAsString}-${suffix}`;
        }

        usedNumbers.add(candidate);
        return candidate;
    };

    const ensureUniqueContainerNumbers = (samples) => {
        const usedContainerNumbersBySample = new Map();

        return samples.map((sample) => {
            const sampleName = sample?.newContainer?.sampleName ?? sample?.sample?.sampleName;
            const containerNumber = sample?.newContainer?.containerNumber;

            if (!sample?.newContainer || !sampleName || containerNumber === null || containerNumber === undefined || containerNumber === '') {
                return sample;
            }

            if (!usedContainerNumbersBySample.has(sampleName)) {
                usedContainerNumbersBySample.set(sampleName, new Set());
            }
            const usedContainerNumbers = usedContainerNumbersBySample.get(sampleName);

            const uniqueContainerNumber = getUniqueContainerNumber(containerNumber, usedContainerNumbers);

            if (uniqueContainerNumber === containerNumber) {
                return sample;
            }

            return {
                ...sample,
                newContainer: {
                    ...sample.newContainer,
                    containerNumber: uniqueContainerNumber
                }
            };
        });
    };

    async function LoadContainers() {
        const validContainers = containersFiltered.filter(
            c => !(c?.newContainerID > 0 || c.isRequestContainer === false)
        );

        if (validContainers.length === 0) {
            openModalMessages("Error Loading Containers", "No request containers are available for recommendations.");
            return;
        }

        if (validContainers.some(c => !c.existingContainerID || !c.existingContainer?.id)) {
            openModalMessages("Error Loading Containers", "Select a parent container for each sample before getting recommendations.");
            return;
        }

        if (methods.some(s => !s.methodFacility)) {
            openModalMessages("Error!", "The method and facility fields are required");
            return;
        }

        if (containeringMethod === "existing" && methods.some(result => !result.containerSelectionType)) {
            openModalMessages("Error Loading Containers", "Select a container option for each method before getting recommendations.");
            return;
        }

        let allTests = [];
        
        for (const selectedMyContainer of validContainers) {
            for (const oMethodInfo of methods) {
                let myContainerID = null;
                if (oMethodInfo.containerSelectionType === "Existing Container") {
                    myContainerID = selectedMyContainer?.existingContainer?.id;
                }
                const tests = await BuildTestingPayload(
                    oMethodInfo,
                    selectedMyContainer?.existingContainer,
                    myContainerID,
                    selectedMyContainer?.existingContainer?.chargeCode ? selectedMyContainer?.existingContainer?.chargeCode : null,
                    ownerContainer
                );
                
                if (tests === null || typeof tests === 'string' || typeof tests[0] === 'string') {
                    if (Array.isArray(tests)) {
                        openModalMessages("Error Building Tests", tests);
                        return;
                    } else {
                        openModalMessages("Error Building Tests", `There was an error building the test payload. ${tests ? tests : ''}`);
                        return;
                    }
                }
                
                // Adjust testPriorityName and returnLocationName if needed
                const isRush = myWorkRequest?.priorityName === "Rush";
                const locationName = selectedMyContainer?.requestedLocationName;
                
                tests.forEach(test => {
                    if (isRush) {
                        test.testPriorityName = "Rush";
                        test.testPriority = null;
                    }
                    if (locationName && test.container) {
                        test.container.returnLocationName = locationName;
                    }
                });
                
                for (const oTest of tests) {
                    allTests.push(oTest);
                }
            }
        }

        var testingInfo = {
            tests: allTests,
            containeringMethod: containeringMethod,
            requireParentContainer: true
        };

        openModalNoButton("Generating Containers", "Please wait while containers are generated...");

        return Container.GetContainersToCreate(JSON.stringify(testingInfo)).then((res) => {
            closeModalNoButton();

            if (res && res.message === 'Success') {
                res.result.forEach((oContainer) => {
                    if (oContainer.id === 0) {
                        oContainer.locationName = null;
                        oContainer._originalAmount = oContainer.currentAmount;
                        oContainer._originalUoM = oContainer.uom;
                    } else {
                        oContainer.parentID = oContainer.id;
                        oContainer.id = 0;
                    }
                });

                setMySamplesInfo(prev => {
                    const filtered = prev.filter(
                        sample => !(sample.isRequestContainer === false && sample.id === 0)
                    );
                    
                    const containersByParent = {};
                    res.result.forEach((container) => {
                        const parentId = container.parentID;
                        if (!containersByParent[parentId]) {
                            containersByParent[parentId] = [];
                        }
                        containersByParent[parentId].push(container);
                    });
                    
                    const newSamples = [];
                    
                    filtered.forEach((sample, sampleIdx) => {
                        if (!sample.isRequestContainer) return;
                        
                        const parentId = sample.existingContainerID;
                        const containersForThisParent = containersByParent[parentId] || [];
                        
                        if (containersForThisParent.length > 0) {
                            const firstContainer = containersForThisParent[0];
                            firstContainer.ownerEmail = ownerContainer ?? sample?.existingContainer?.requesterEmail;
                            firstContainer.returnLocationName = firstContainer.returnLocationName ?? sample.requestedLocationName;
                            firstContainer.returnLocation = firstContainer.returnLocationName ? availableLocations.find(obj => obj.locationName === firstContainer.returnLocationName) : null;
                            firstContainer.location = firstContainer.locationName ? availableLocations.find(obj => obj.locationName === firstContainer.locationName) : null;
                            
                            filtered[sampleIdx] = {
                                ...filtered[sampleIdx],
                                newContainer: firstContainer
                            };
                            
                            for (let i = 1; i < containersForThisParent.length; i++) {
                                const additionalContainer = containersForThisParent[i];
                                additionalContainer.ownerEmail = ownerContainer ?? sample?.existingContainer?.requesterEmail;
                                additionalContainer.returnLocationName = additionalContainer.returnLocationName ?? sample.requestedLocationName;
                                additionalContainer.returnLocation = additionalContainer.returnLocationName ? availableLocations.find(obj => obj.locationName === additionalContainer.returnLocationName) : null;
                                additionalContainer.location = additionalContainer.locationName ? availableLocations.find(obj => obj.locationName === additionalContainer.locationName) : null;
                                
                                let sampleCopy = JSON.parse(JSON.stringify(sample));
                                sampleCopy.id = 0;
                                sampleCopy.newContainer = additionalContainer;
                                sampleCopy.isRequestContainer = false;
                                newSamples.push(sampleCopy);
                            }
                        }
                    });
                    
                    if (newSamples.length > 0) {
                        filtered.push(...newSamples);
                    }

                    return ensureUniqueContainerNumbers(filtered);
                });
            } else {
                openModalMessages("Error Loading Containers", `There was an error loading the testing/retain containers for the selected tests and containering method. ${res ? res.message : ''}.`);
            }
        });
    }

    function closeModalMessages() {
        setModalMessagesOpen(false);
    }

    function openModalMessages(title, text) {
        setModalMessagesOpen(true);
        setModalMessagesTitle(title);
        setModalMessagesText(text);
    }

    function openPrintingOptions(sampleList, onlyWithBlindCode) {
        let arrayPrintInfo = [];
        if (sampleList?.length > 0) {
            sampleList.forEach((dataTable) => {
                if (dataTable?.sample && dataTable?.newContainer) {
                    const containerNumbers = [`${dataTable.newContainer?.containerNumber}`];
                    let newPrintInfo = new PrintLabel({
                        sampleName: dataTable.sample.sampleName,
                        containerNumbers: containerNumbers,
                        includeAdditionalSampleInformation: false,
                        chemIDOnly: false,
                        printLabelSizeType: null,
                        isBlindCoded: onlyWithBlindCode,
                        blindDescription: null,
                        blindSampleName: null,
                        isShelfLabel: false,
                        shelfLabelText: null,
                        includeShelfBarcode: false
                    });
                    arrayPrintInfo.push(newPrintInfo);
                }
            });
            setPrintLabelInfo(arrayPrintInfo);
            setPrintInfoOpen(true);
        } else {
            openModalMessages('', 'A container needs to be created to be able to print!');
        }
    }

    function closePrintInformation() {
        setPrintInfoOpen(false);
    }

    const UpdateContainerManagementType = (e) => {
        setContaineringMethod(e.target.value);
    };

    const UpdateMethodContainering = (value, methodInfo, property, updateAllMethods) => {
        let copyMethods = JSON.parse(JSON.stringify(methods));
        if (updateAllMethods) {
            for (var i = 0; i < copyMethods.length; i++) {
                copyMethods[i].createFromContainer = value;
            }
        } else {
            let methodIndex = copyMethods.findIndex(s => s.method.name === methodInfo.methodName && s.methodFacility.testFacilityAbv === methodInfo.facility && (s.conditionOffering ? s.conditionOffering.conditionOfferingName === methodInfo.conditionOfferingName : true));
            copyMethods[methodIndex][property] = value;
        }
        setMethods(copyMethods);
        //setTriggerContainerReload(true);
    };

    function closeModalNoButton() {
        setModalNoButtonOpen(false);
    }

    function openModalNoButton(title, text) {
        setModalNoButtonOpen(true);
        setModalNoButtonTitle(title);
        setModalNoButtonText(text);
    }

    const handleCreateContainers = async () => {
        setLoading(true);
        const [data] = await prepareData(myWorkRequest, false, true);

        WorkRequest.createContainers(data)
            .then((res) => {
                setLoading(false);
                if (res && res.result && Array.isArray(res.result.workRequestSamples)) {
                    // setMySamplesInfo(prev => {
                    //     const updated = [...prev];
                    //     res.result.workRequestSamples.forEach((returnedSample) => {
                    //         const idx = updated.findIndex(
                    //             s =>
                    //                 (s.id && returnedSample.id && s.id === returnedSample.id) ||
                    //                 (s.existingContainerID && returnedSample.existingContainerID && s.existingContainerID === returnedSample.existingContainerID)
                    //         );
                    //         if (idx !== -1) {
                    //             updated[idx] = {
                    //                 ...updated[idx],
                    //                 newContainer: returnedSample.newContainer,
                    //                 newContainerID: returnedSample.newContainerID
                    //             };
                    //         }
                    //     });
                    //     return updated;
                    // });
                    const newSamplesInfo = res.result.workRequestSamples.map((returnedSample) => {
                        const oldSample = mySamplesInfo.find(
                            s =>
                                (s.existingContainerID === returnedSample.existingContainerID)
                        );
                        return {
                            ...returnedSample,
                            sample: oldSample?.sample ?? returnedSample.sample,
                            newContainer: {
                                ...returnedSample.newContainer,
                                tests: returnedSample.newContainer.tests.map(test => {
                                    const matchingTest = oldSample.newContainer.tests.find(t => t.methodFacilityID === test.methodFacilityID);

                                    return {
                                        ...test,
                                        methodFacility: matchingTest ? matchingTest.methodFacility : test.methodFacility
                                    }
                                })
                            }
                        };
                    })
                    setMySamplesInfo(newSamplesInfo);
                    openModalMessages("Creating Containers", `Created containers with success`);
                    openPrintingOptions(newSamplesInfo);
                    setDisablePrintContainers(false);
                } else {
                    openModalMessages("Error Creating Containers", `There was an error creating containers. ${res.message ? res.message : ''}`);
                }
            });
    };

    const containersFiltered = selectedMyContainers.filter(f => f.isRequestContainer);

    // Assign unique negative temp IDs to new containers (id=0/null) so ContainerTable's
    // findIndex resolves by id instead of containerNumber, fixing duplicate-containerNumber edits.
    const containersForTable = selectedMyContainers
        .map((s, globalIdx) => {
            if (!s?.newContainer) return null;
            const c = s.newContainer;
            return (!c.id || c.id <= 0) ? { ...c, id: -(globalIdx + 1) } : c;
        })
        .filter(Boolean);

    return (
        <div className="work-request-container-management">
            <p style={{ paddingTop: "16px" }}></p>
            <FormControl disabled={readOnly}>
                <RadioGroup
                    rows="true"
                    aria-labelledby="row-radio-buttons-group-label"
                    name="container-radio-buttons-group"
                >
                    <div style={{ display: "flex" }}>
                        <FormControlLabel value="nonsplit" control={<Radio checked={containeringMethod === 'nonsplit'} onChange={UpdateContainerManagementType} />} label="Make NonSplit" />
                        <HelpIcon style={{ marginTop: ".5rem", color: "blue" }} onClick={(e) => openModalMessages("Container Info", globalMessages.NonSplitMsg)}></HelpIcon>
                    </div>
                    <div style={{ display: "flex" }}>
                        <FormControlLabel value="midas" control={<Radio checked={containeringMethod === 'midas'} onChange={UpdateContainerManagementType} />} label="MIDAS Recommendation" />
                        <HelpIcon style={{ marginTop: ".5rem", color: "blue" }} onClick={(e) => openModalMessages("Container Info", globalMessages.MidasMsg)}></HelpIcon>
                    </div>
                    <div style={{ display: "flex" }}>
                        <FormControlLabel value="existing" control={<Radio checked={containeringMethod === 'existing'} onChange={UpdateContainerManagementType} />} label="Existing Container" />
                        <HelpIcon style={{ marginTop: ".5rem", color: "blue" }} onClick={(e) => openModalMessages("Container Info", globalMessages.existingMsg)}></HelpIcon>
                    </div>
                </RadioGroup>
            </FormControl>
            <p style={{ paddingTop: "16px" }}></p>
            <UXDataTableWithoutBody
                tableWidth={containeringMethod === 'existing' ? '60%' : '70%'}
                cols={containeringMethod === 'existing' ? midasColHeaders_Existing : midasColHeaders}
                blankFirstHeader={false}
                tableId="containerTableAll"
                rowLength={1}
                enablePaging={false}
                rowsPerPage={0}
                page={0}
                handleChangePage={null}
                handleChangeRowsPerPage={null}
                noDataFoundMessage={'No containers found'}
                enableAddIcon={false}
                addFunction={null}
                addToolTipText={null}
                isDataLoading={false}
            >
                <StyledTableBody>
                    <TableRow>
                        <StyledTableCell className="work-request-wrap-cell">
                            {containersFiltered.map(c => formatMidasNumber(c?.sample?.sampleName)).join('\n')}
                        </StyledTableCell>
                        {containeringMethod === 'existing' ? (
                            <>
                                <StyledTableCell>
                                    View
                                    <IconButton
                                        aria-label='expand row'
                                        size='small'
                                        onClick={() => {
                                            // Usa uma chave fixa, pois é uma linha só
                                            const rowKey = 'all-containers-row';
                                            if (sampleRowOpen.includes(rowKey)) {
                                                setSampleRowOpen(sampleRowOpen.filter(k => k !== rowKey));
                                            } else {
                                                setSampleRowOpen([...sampleRowOpen, rowKey]);
                                            }
                                        }}
                                    >
                                        {sampleRowOpen.includes('all-containers-row') ? (
                                            <KeyboardArrowUpIcon />
                                        ) : (
                                            <KeyboardArrowDownIcon />
                                        )}
                                    </IconButton>
                                </StyledTableCell>
                                <StyledTableCell className="work-request-wrap-cell">
                                    {containersFiltered.map(c => c?.sample?.description).join('\n')}
                                </StyledTableCell>
                            </>
                        ) : (
                            <>
                                <StyledTableCell className="work-request-wrap-cell">
                                    {containersFiltered.map(() =>
                                        `${minSampleSize} ${masterUoM ? masterUoM.uoMName : '???'}`
                                    ).join('\n')}
                                </StyledTableCell>
                                <StyledTableCell className="work-request-wrap-cell">
                                    {containersFiltered.map(c => c?.existingContainer?.containerNumber).join('\n')}
                                </StyledTableCell>
                                <StyledTableCell className="work-request-wrap-cell">
                                    {containersFiltered.map(() =>
                                        methods[0]?.createFromContainer
                                            ? `${methods[0]?.createFromContainer?.currentAmount} ${methods[0].createFromContainer?.containerSizeUoM}`
                                            : ''
                                    ).join('\n')}
                                </StyledTableCell>
                                <StyledTableCell className="work-request-wrap-cell">
                                    {containersFiltered.map(c => c?.sample?.description).join('\n')}
                                </StyledTableCell>
                            </>
                        )}
                    </TableRow>
                    {/* Detalhes expandido para todos os containers */}
                    {containeringMethod === 'existing' && sampleRowOpen.includes('all-containers-row') && (
                        <TableRow>
                            <StyledTableCell colSpan={midasColHeaders_Existing.length}>
                                <UXDataTableWithoutBody
                                    tableWidth={'100%'}
                                    cols={existingColHeaders}
                                    blankFirstHeader={false}
                                    tableId={`existingDetails`}
                                    rowLength={methods.length}
                                    enablePaging={false}
                                    rowsPerPage={0}
                                    page={0}
                                    handleChangePage={null}
                                    handleChangeRowsPerPage={null}
                                    noDataFoundMessage={'No methods found'}
                                    enableAddIcon={false}
                                    addFunction={null}
                                    addToolTipText={null}
                                    isDataLoading={false}
                                >
                                    <StyledTableBody>
                                        {methods.map((methodObj, methodIndex) => (
                                            <TableRow key={methodIndex}>
                                                <StyledTableCell>{methodObj.method?.name}</StyledTableCell>
                                                <StyledTableCell align="left">
                                                    <Autocomplete
                                                        disabled={selectedMyContainers.some(s => s.newContainerID > 0)}
                                                        disablePortal
                                                        options={["Create From Parent", "Existing Container"]}
                                                        onChange={(e, value) => UpdateMethodContainering(value, { methodName: methodObj.method?.name, facility: methodObj.methodFacility.testFacilityAbv, conditionOfferingName: methodObj.conditionOffering?.conditionOfferingName }, 'containerSelectionType', false)}
                                                        getOptionLabel={(option) => option}
                                                        value={methodObj.containerSelectionType}
                                                        isOptionEqualToValue={(option, value) => value === option}
                                                        style={{ fontFamily: "EMprint", fontSize: "16px" }}
                                                        renderInput={(params) => <TextField {...params} style={{ width: "230px" }} variant="outlined" size="small" error={methodObj.containerSelectionError} InputProps={{ ...params.InputProps }} />} />
                                                </StyledTableCell>
                                                <StyledTableCell align="left" className="work-request-wrap-cell">
                                                    {containersFiltered.map(c => formatMidasNumber(c?.existingContainer?.containerNumber)).join('\n')}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {RoundNumber(GetRequiredSampleSize(methodObj), 2)} {GetRequiredSampleSizeUoM(methodObj)}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {methodObj.createFromContainer ? methodObj.createFromContainer.currentAmount : 'N/A'} {methodObj.createFromContainer ? methodObj.createFromContainer.containerSizeUoM : ''}
                                                </StyledTableCell>
                                            </TableRow>
                                        ))}
                                    </StyledTableBody>
                                </UXDataTableWithoutBody>
                            </StyledTableCell>
                        </TableRow>
                    )}
                </StyledTableBody>
                <Box padding={'10px'}>
                    <GlobalButton
                        variant="contained"
                        onClick={() => setOnGetRecommendation(true)}
                        disabled={
                            selectedMyContainers.some(c => c?.newContainerID > 0) ||
                            myWorkRequest?.statusName === 'Completed'
                        }
                    >
                        Get Recommendation
                    </GlobalButton>
                </Box>
            </UXDataTableWithoutBody>
            {containeringMethod && containeringMethod !== '' && <StyledP>Containers to Create</StyledP>}
            {containeringMethod && containeringMethod !== '' && selectedMyContainers?.length === containerErrorChecks?.length &&
                <ContainerTable
                    width={'95%'}
                    showParentMidas={true}
                    showParentContainer={false}
                    showWorkRequestTests={true}
                    containers={containersForTable}
                    setContainers={updatedContainers => {
                        let containerIdx = 0;
                        setMySamplesInfo(selectedMyContainers.map(sample => {
                            if (!sample?.newContainer) return sample;
                            const updated = updatedContainers[containerIdx++] ?? sample?.newContainer;
                            // Strip temp negative IDs before storing back
                            return {
                                ...sample,
                                newContainer: updated.id < 0 ? { ...updated, id: 0 } : updated
                            };
                        }));
                    }}
                    containerErrorChecks={containerErrorChecks.map(e => e.containerErrorInfo)}
                    setContainerErrorChecks={(oErrorsArr, index) => {
                        setContainerErrorChecks(oErrorsArr.map((oErrors, idx) => ({
                            containerErrorInfo: oErrors.map(err => ({
                                ...err,
                                location: index === idx ? oErrors.location ?? err.location : err.location
                            }))
                        })));
                    }}
                    enabledAdditions={false}
                    enableDeletions={false}
                    enableCopy={false}
                    availableParentContainers={null}
                    sampleObject={selectedMyContainers.filter(s => s?.newContainer).map(s => s?.sample)}
                    substanceObject={selectedMyContainers.filter(s => s?.newContainer).map(s => s?.sample?.substance)}
                    lockContainerStatus={true}
                    newContainerDefaultOwner={null}
                    readOnly={selectedMyContainers.every(c => c?.newContainerID > 0)}
                />
            }

            {/* Bloco único de ações */}
            {containeringMethod && containeringMethod !== '' &&
                <>
                    <GlobalButton
                        disabled={
                            hasError ||
                            selectedMyContainers.every(c => c?.newContainerID > 0) ||
                            selectedMyContainers.some(c => !c?.newContainer) ||
                            loading ||
                            methods.some(s => !s.methodFacility) ||
                            myWorkRequest?.statusName === 'Completed'
                        }
                        variant="contained"
                        onClick={async () => {
                            let errorMessages = [];
                            
                            selectedMyContainers.forEach((selectedMyContainer) => {
                                const container = selectedMyContainer?.newContainer;
                                const sampleName = selectedMyContainer?.sample?.sampleName;
                                const containerNumber = container?.containerNumber;
                                
                                if (!container?.location) {
                                    errorMessages.push(
                                        `A Container Initial Location is required on sample ${sampleName} on Container ${containerNumber}.`
                                    );
                                }
                                
                                if (!container?.ownerEmail) {
                                    errorMessages.push(
                                        `A Container Owner Email is required on sample ${sampleName} on Container ${containerNumber}.`
                                    );
                                }
                            });
                            
                            if (errorMessages.length > 0) {
                                openModalMessages("Containering Errors", errorMessages.join('\n'));
                                return;
                            }
                            
                            await handleCreateContainers();
                        }}
                    >
                        Create Containers
                        {loading ? (
                            <CircularProgress
                                sx={{ marginLeft: "10px", color: "white" }}
                                size={20}
                            />
                        ) : (
                            ""
                        )}
                    </GlobalButton>
                    <GlobalButton
                        style={{ width: 160, marginLeft: "10px" }}
                        name="printLabels"
                        variant="contained"
                        disabled={disablePrintContainers && mySamplesInfo.every(s => !s.newContainerID)}
                        onClick={() => {
                            openPrintingOptions(mySamplesInfo);
                        }}
                    >
                        Print labels
                    </GlobalButton>
                </>}
            <ModalMessages title={modalMessagesTitle} buttonText={modalMessagesButtonText} buttonAction={closeModalMessages} open={modalMessagesOpen} setOpen={setModalMessagesOpen}>
                <label style={{ whiteSpace: 'pre-line' }}>
                    {modalMessagesText}
                </label>
            </ModalMessages>
            <ModalNoButton title={modalNoButtonTitle} open={modalNoButtonOpen} setOpen={setModalNoButtonOpen}>
                <label>
                    {modalNoButtonText}
                </label>
            </ModalNoButton>
            <PrintInformation
                open={printInfoOpen}
                setOpen={setPrintInfoOpen}
                button2Action={closePrintInformation}
                button2Text={"Close"}
                printLabelInfo={printLabelInfo}
                isShelfLabel={false}
                useFieldsBlindCode={false}
            ></PrintInformation>
        </div>
    );
};

export default WorkRequestContainerManagement;